import { isBefore, parseISO, startOfDay } from 'date-fns';

import type { EmployeeStatus } from '@/types/employee';

export type DisplayedEmployeeStatus =
  | 'active'
  | 'probation'
  | 'onboarding'
  | 'offboarding'
  | 'deactivated';

export function deriveDisplayedEmployeeStatus(input: {
  status: EmployeeStatus;
  terminationDate?: string | null;
}): DisplayedEmployeeStatus {
  switch (input.status) {
    case 'active':
      return 'active';
    case 'probation':
      return 'probation';
    case 'onboarding':
      return 'onboarding';
    case 'terminated': {
      if (!input.terminationDate) return 'deactivated';
      // Strip time portion: API returns date-only values as "YYYY-MM-DDT00:00:00.000Z"
      // and parsing that as UTC drifts to the previous calendar day in TZs west of UTC.
      const td = startOfDay(parseISO(input.terminationDate.slice(0, 10)));
      return isBefore(td, startOfDay(new Date())) ? 'deactivated' : 'offboarding';
    }
  }
}
